// extracted by mini-css-extract-plugin
export var container = "index-module--container--Peqbg";
export var description = "index-module--description--ik5hb";
export var thumbnail = "index-module--thumbnail--45iKW";
export var title = "index-module--title--+tELl";